import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Button from 'aria-viewer/tour/components/buttons/button'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import withNativeAppDeeplink from 'aria-viewer/utils/withNativeAppDeeplink'
import Icon from 'aria-viewer/tour/components/icon'
import { MAIN_VR_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { sendHybridAppAnalyticsEvents, vrButtonTapped } from 'aria-viewer/analytics/analyticActions'
import { M_MOBEXP_VRBUTTON_CLICKED, M_MOBEXP_VRBUTTON_VISIBLE } from 'aria-viewer/analytics/constants/mobileAnalytics'

export const VR_BUTTON_LOCATION = {
    mobile: {
        tourButtonPanel: 'tourButtonPanel',
        clientInfoMenu: 'clientInfoMenu',
    },
}

class VrButton extends PureComponent {
    constructor(props) {
        super(props)
        this.isVrButtonVisibleAnalyticsFired = false
    }

    handleTriggerDeepLink = () => {
        if (this.props.buttonLocation) {
            this.props.vrButtonTapped({ buttonLocation: this.props.buttonLocation })
        }
        this.props.triggerDeeplink({
            deepLinkAnalyticsCB: this.props.sendHybridAppAnalyticsEvents({ event: M_MOBEXP_VRBUTTON_CLICKED }),
        })
    }

    getIcon() {
        return (
            !this.props.puresvg && (
                <div
                    style={{
                        width: '46px',
                        height: '46px',
                        display: 'inline-block',
                        ...this.props.iconContainerStyle,
                    }}
                >
                    <Icon
                        icon="vr"
                        style={Object.assign(
                            {},
                            {
                                backgroundSize: '60%',
                                backgroundPosition: '50%',
                            },
                            this.props.iconStyle
                        )}
                    />
                </div>
            )
        )
    }

    componentWillReceiveProps(nextProps) {
        const { sendHybridAppAnalyticsEvents, loading, isVrModuleEnabled } = nextProps

        if (isVrModuleEnabled && !loading && !this.isVrButtonVisibleAnalyticsFired) {
            sendHybridAppAnalyticsEvents({ event: M_MOBEXP_VRBUTTON_VISIBLE })
            this.isVrButtonVisibleAnalyticsFired = true
        }
    }

    render() {
        return (
            this.props.isVrModuleEnabled && (
                <Button
                    className={this.props.className || ''}
                    style={this.props.style}
                    tabIndex={MAIN_VR_BUTTON_INDEX}
                    id="vr"
                    onClick={this.handleTriggerDeepLink}
                    altRespectCase="VR"
                    alt="VR"
                    theme={this.props.theme}
                    {...this.props}
                >
                    {this.props.children}
                    {this.getIcon()}
                </Button>
            )
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'isVrModuleEnabled',
        'loading',
        //location, client, and currentStop are here because we are extending from DeepLink
        'location',
        'client',
        'currentStop',
    ]),
    { sendHybridAppAnalyticsEvents, vrButtonTapped }
)(
    /* Allow us to do actual deeplink logic */
    withNativeAppDeeplink(VrButton)
)
